<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit='openEdit'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Description</td>
            <td :class='dataValue'>{{ item.description }}</td>
          </tr>
          <tr>
            <td :class='label'>Number</td>
            <td :class='dataValue'>{{ item.number }}</td>
          </tr>
          <tr>
            <td :class='label'>App Order</td>
            <td :class='dataValue'>{{ item.app_order }}</td>
          </tr>
          <tr>
            <td :class='label'>Notes:</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text class='pt-0'>{{ item.notes }}</v-card-text>
    </wc-data-box>
  <!-- edit dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      title='Edit Basics'
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      width='400'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
    >
      <v-form ref='form'>
        <v-text-field
          label='Description'
          :rules='[rules.required]'
          v-model='itemCopy.description'
        ></v-text-field>
        <v-row>
          <v-col cols='6'>
            <v-text-field
              label='Number'
              :rules='[rules.required]'
              v-model='itemCopy.number'
              hint='MIL inventory number'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='6'>
            <v-text-field
              label='App Order'
              v-model='itemCopy.app_order'
              hint='list sorting order'
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <span>Notes</span>
        <v-textarea outlined auto-grow v-model='itemCopy.notes'></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'inventory-basics',
  props: {
    item: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right',
    showDialog: false,
    isLoading: false,
    itemCopy: {},
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.basics }
  },
  methods: {
    openEdit () {
      this.itemCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.isLoading = true
      this.$emit('update', this.itemCopy)
      this.cancelEdit()
      this.isLoading = false
    }
  }
}
</script>